import he from "./he";
import en from "./en";
import fr from "./fr";
import du from "./du";
import ge from "./ge";
import it from "./It";
import po from "./po";
import sp from "./sp";

export const languages = {
  he: {
    translation: he,
  },
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
  sp: {
    translation: sp,
  },
  po: {
    translation: po,
  },
  it: {
    translation: it,
  },
  ge: {
    translation: ge,
  },
  du: {
    translation: du,
  },
};
